export default function getQuillStyles(colorMode) {
  return {
    '.ql-toolbar .ql-stroke': {
      stroke: colorMode === 'dark' ? '#fff' : '#000',
    },
    '.ql-toolbar .ql-fill': {
      fill: colorMode === 'dark' ? '#fff' : '#000',
    },
    '.ql-toolbar .ql-picker': {
      color: colorMode === 'dark' ? '#fff' : '#000',
    },
    '.ql-toolbar .ql-picker-options': {
      backgroundColor: colorMode === 'dark' ? '#2D3748' : '#fff',
    },
    '.ql-toolbar .ql-picker-item': {
      color: colorMode === 'dark' ? '#fff' : '#000',
    },
    '.ql-toolbar .ql-picker-label': {
      backgroundColor: colorMode === 'dark' ? '#2D3748' : '#fff',
    },
    '.ql-editor.ql-blank::before': {
      color:
        colorMode === 'dark'
          ? 'rgba(255, 255, 255, 0.9)'
          : 'rgba(0, 0, 0, 0.6)',
    },
    '.ql-toolbar button.ql-active .ql-stroke': {
      stroke: '#38A169',
    },
    '.ql-toolbar button.ql-active .ql-fill': {
      fill: '#38A169',
    },
    '.ql-toolbar .ql-picker-label.ql-active': {
      color: '#38A169',
    },
    '.ql-toolbar .ql-picker-item.ql-selected': {
      color: '#38A169',
    },
    '.ql-toolbar button:hover .ql-stroke': {
      stroke: '#38A169',
    },
    '.ql-toolbar button:hover .ql-fill': {
      fill: '#38A169',
    },
    '.ql-toolbar .ql-picker-item:hover': {
      color: '#38A169',
    },
  };
}
